import PageProduct from '@/components/PageProduct';

export default PageProduct;

export async function getStaticProps() {
  return {
    props: {
      path: '/gluecksspirale',
      theme: 'gluecksspirale',
      description:
        'GlücksSpirale auf einen Blick ✓: GlücksSpirale-Lose online für eine Sofortrente, aktuelle Gewinnzahlen und eine kurze Spielanleitung',
      title: 'GlücksSpirale ► Lotterie-Übersicht | LOTTO.de',
      contents: {
        name: 'contents',
        nodes: [
          {
            template: 'lotto:components/pageHeading',
            value: 'GlücksSpirale',
          },
          {
            template: 'lotto:components/section',
            link: {
              path: '/gluecksspirale/gewinnzahlen',
            },
            title: 'Die aktuellen Gewinnzahlen',
            linkLabel: 'Alle Gewinnzahlen & Quoten',
            contents: {
              name: 'contents',
              nodes: [
                {
                  template: 'lotto:components/winningNumbers',
                  variant: 'gluecksspirale',
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            title: 'GlücksSpirale auf einen Blick',
            contents: {
              name: 'contents',
              nodes: [
                {
                  template: 'lotto:components/iconList',
                  contents: {
                    name: 'contents',
                    nodes: [
                      {
                        text: '5,00 € je Teilnahme zuzüglich Bearbeitungsgebühren je Spielschein',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-money',
                        title: 'Spieleinsatz',
                      },
                      {
                        text: '1,2 Mio. € sofort + 5.000 €/Monat, 20 Jahre lang, gewinnen Sie mit einer Chance von 1 zu 10.000.000',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-draw',
                        title: 'Gewinnwahrschein­lichkeit',
                      },
                      {
                        text: 'Jeden Samstag werden die GlücksSpirale-Gewinnzahlen gezogen',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-tv',
                        title: 'Ziehungen',
                      },
                      {
                        text: 'Sie können 1, 2, 3, 4 oder 5 Wochen oder direkt im Dauerspiel mitspielen',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-calendar',
                        title: 'Spielschein-Laufzeit',
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            title: 'So funktioniert die GlücksSpirale',
            contents: {
              name: 'contents',
              nodes: [
                {
                  template: 'lotto:components/cardSlider',
                  contents: {
                    name: 'contents',
                    nodes: [
                      {
                        text: '<p>Die Losnummer auf einem <a href="/gluecksspirale/spielen">GlücksSpirale-Spielschein</a> können Sie einfach per Eingabe von Nummern ändern oder per Zufall eine neue Nummer generieren. Mit der Spielscheinnummer definieren Sie auch die Nummern für die <a href="/lotto-6aus49/spiel77-super6/spielregeln">Zusatzlotterien Spiel 77 und SUPER 6</a>.</p>\n',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        title: '1. GlücksSpirale-Losnummer wählen',
                        labelPrev: 'Vorheriger Schritt',
                      },
                      {
                        text: '<p>Sie möchten auch an den Zusatzlotterien Spiel 77 oder SUPER 6 teilnehmen? Dann müssen Sie einfach die gewünschte Zusatzlotterie anklicken.</p>\n',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        title: '2. Teilnahme an Zusatzlotterien',
                        labelPrev: 'Vorheriger Schritt',
                      },
                      {
                        text: '<p>Als Teilnahmezeitraum für Ihr <a href="/gluecksspirale/spielen">GlücksSpirale-Los</a> können Sie zwischen einer und fünf Wochen wählen. Mit einem Dauerspiel wird Ihr Spielschein bei Ihrer Landeslotteriegesellschaft automatisch verlängert.</p>\n',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        title: '3. Teilnahmezeitraum festlegen',
                        labelPrev: 'Vorheriger Schritt',
                      },
                      {
                        text: '<p>Ihren Spieltipp für die Abgabe bei Ihrer Landeslotteriegesellschaft fassen wir noch einmal in einer Übersicht mit allen relevanten Angaben zusammen.</p>\n',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        title: '4. Übersicht Ihres Spieltipps',
                        labelPrev: 'Vorheriger Schritt',
                      },
                      {
                        text: '<p>Ihr <a href="/gluecksspirale/spielen">GlücksSpirale-Los</a> können Sie bei der Landeslotteriegesellschaft Ihres Bundeslandes abgeben. Falls Sie dort bereits registrierter Nutzer sind, können Sie sich einfach anmelden und den Spielschein abgeben. Falls Sie noch kein Kunde einer Landeslotteriegesellschaft sind, müssen Sie erst den Registrierungsprozess in Ihrem Bundesland abschließen.</p>\n',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        title: '5. Anmelden oder registrieren',
                        labelPrev: 'Vorheriger Schritt',
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            title: 'Neuigkeiten von der GlücksSpirale',
            hideLine: false,
            contents: {
              name: 'contents',
              nodes: [
                {
                  category: 'gluecksspirale',
                  template: 'lotto:components/newsTeaser',
                  amount: 2,
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            title: 'Sicherheit bei LOTTO.de',
            hideLine: true,
            contents: {
              name: 'contents',
              nodes: [
                {
                  template: 'lotto:components/iconList',
                  contents: {
                    name: 'contents',
                    nodes: [
                      {
                        text: 'Wir leiten Ihren Spielschein-Tipp mit einer sicheren Verbindung an die Landes­lotterie­gesellschaft Ihres Bundeslandes weiter - dort können Sie online spielen.',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-shield',
                        title: 'Sicher & legal',
                      },
                      {
                        text: 'Rechtliche Grundlage für erlaubtes Glücksspiel in Deutschland sind der Glücksspiel­staatsvertrag und die Glücksspiel­gesetze der Länder.',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-court',
                        title: 'Staatlich erlaubt',
                      },
                      {
                        text: 'Im Gewinnfall haben Sie bei staatlich erlaubten Lotterien einen Rechtsanspruch auf eine garantierte Auszahlung durch die Landes­lotterie­gesellschaften.',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-payoff',
                        title: 'Garantierte Auszahlung',
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            hideLine: true,
            contents: {
              name: 'contents',
              nodes: [
                {
                  game: '2',
                  template: 'lotto:components/linkGame',
                },
              ],
            },
          },
        ],
      },
    },
  };
}
